import { Flex, Form } from "antd";
import { RcFile } from "antd/lib/upload";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";

import { uploadRuleFile } from "services";
import { useStores } from "stores";
import { CustomButton, FileInput, FileType, UploadedFileDisplay } from "ui";
import { parseErrorMessage } from "utils";

export const AddRuleFileModal = observer(() => {
  const { actionModals, settings } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const [uploadedFile, setUploadedFile] = useState<FileType | null>(null);

  const addRuleFileHandler = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", uploadedFile as FileType);

    await uploadRuleFile({ file: formData })
      .then(() => {
        handleCloseModal();
        setTimeout(() => {
          settings.fetchRuleFiles();
          setLoading(false);
        }, 1500);
        openNotification({
          message: "Файл успешно загружен",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
      })
      .catch((e) => {
        openNotification({
          type: NOTIFICATION_TYPE_ENUM.ERROR,
          description: parseErrorMessage(e),
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  const handleUploadFile = (files: RcFile[] | undefined) => {
    if (files) {
      setUploadedFile(files[0]);
    }
  };

  const handleRemoveDocument = () => {
    if (loading) return;
    setUploadedFile(null);
  };

  return (
    <Flex vertical gap="large">
      <>
        {uploadedFile ? (
          <UploadedFileDisplay
            fileName={uploadedFile.name}
            onRemove={handleRemoveDocument}
            tooltip="Заменить документ"
          />
        ) : (
          <Flex>
            <FileInput blockTitle="Редакция правил" isLocal={handleUploadFile} className="full-width" />
          </Flex>
        )}
      </>
      <Form.Item>
        <Flex gap="large">
          <CustomButton
            htmlType="button"
            disabled={loading || !uploadedFile}
            loading={loading}
            onClick={addRuleFileHandler}
          >
            Сохранить
          </CustomButton>
          <CustomButton
            htmlType="button"
            disabled={loading}
            loading={loading}
            type="default"
            onClick={handleCloseModal}
          >
            Отмена
          </CustomButton>
        </Flex>
      </Form.Item>
    </Flex>
  );
});
